import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { DEFAULT_TEXTS } from "../texts";

let cache = null;
let listeners = [];

export function refreshTexts() {
  cache = null;
  return loadTexts();
}

async function loadTexts() {
  try {
    const { data } = await axios.get(`${API}/texts`);
    cache = { ...DEFAULT_TEXTS, ...data };
  } catch {
    cache = { ...DEFAULT_TEXTS };
  }
  listeners.forEach((l) => l(cache));
  return cache;
}

export function useTexts() {
  const [texts, setTexts] = useState(cache || DEFAULT_TEXTS);
  useEffect(() => {
    listeners.push(setTexts);
    if (!cache) loadTexts();
    else setTexts(cache);
    return () => {
      listeners = listeners.filter((l) => l !== setTexts);
    };
  }, []);
  return texts;
}
